module.exports = __webpack_public_path__ + "static/Dedicated-Team-banner-f1d653c7f043a0758efa5150fbebfa9f.jpg";